import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCardOnboardingMetalContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CardOnboardingMetalContainer" */
                '@perpay-web/fintech/components/containers/CardOnboardingMetalContainer'
            ),
    );
